/* Route Paths */
import {ROUTES_PREFIX} from '../shared.js';

export const ROUTE_NAME = {
  PAYMENT_SYSTEMS_REGULATOR: `${ROUTES_PREFIX.PUBLIC}/tell-us-about-your-business`,
  PAYMENT_SYSTEMS_OUTPUT_PAGE: `${ROUTES_PREFIX.PUBLIC}/our-card-payments-service`,
  DECLINE_TO_QUOTE: `${ROUTES_PREFIX.PUBLIC}/decline-to-quote`,
  SYSTEM_FAILURE: `${ROUTES_PREFIX.PUBLIC}/system-failure`,
};

export const ROUTE_PATHS = {
  PAYMENT_SYSTEMS_REGULATOR_PATH: ROUTE_NAME.PAYMENT_SYSTEMS_REGULATOR,
  PAYMENT_SYSTEMS_OUTPUT_PAGE_PATH: ROUTE_NAME.PAYMENT_SYSTEMS_OUTPUT_PAGE,
  PSR_HOME_PATH:
    'https://www.lloydsbank.com/business/take-payments-with-cardnet/card-readers.html',
  DECLINE_TO_QUOTE_PATH: ROUTE_NAME.DECLINE_TO_QUOTE,
  CARDNET_LANDING_PAGE:
    'https://www.lloydsbank.com/business/take-payments-with-cardnet.html',
  SYSTEM_FAILURE_PATH: ROUTE_NAME.SYSTEM_FAILURE,
};

export const HEADER = {
  LINK: 'https://www.lloydsbank.com/business/home.html',
};

export const FOOTER = {
  LEGAL: 'Legal',
  LEGALLink: 'https://www.lloydsbank.com/business/legal.html',
  PRIVACY: 'Privacy',
  PRIVACYLink: 'https://www.lloydsbank.com/business/privacy.html',
  SECURITY: 'Security',
  SECURITYLink: 'https://www.lloydsbank.com/business/security.html',
  COOKIES: 'Cookies',
  COOKIESLink: 'https://www.lloydsbank.com/cookies.html',
  CONTACTUS: 'Contact Us',
  CONTACTUSLink:
    'https://www.lloydsbank.com/business/help-and-support/contact-us.html',
};

export const INDUSTRY = 'industry';
export const SECTOR = 'sector';
export const SCHEME_MASTERCARD = 'MASTERCARD';
export const SCHEME_VISA = 'VISA';
export const PCIDSS_UNASSISTED = 'I’ll be managing it myself.';
export const QUOTE_PROVIDED = 'QUOTE_PROVIDED';
export const NO_QUOTE = 'NO_QUOTE';
export const OTHER_MONTHLY_CHARGES = 'other_monthly_charges';
export const OTHER_DETAILS = 'other_details';
export const EXAMPLE = 'example';
export const CARD_PAYMENTS = 'card_payments';
